import TourGamesHomeView from './TourGamesHomeView';
export default TourGamesHomeView;
